const selectRootFlashcards = state => state.flashcards;

export const selectFlashcards = state => selectRootFlashcards(state).flashcards;
